import dayjs from "dayjs";
import { DEFAULT_CURRENCY, currencySymbol } from "@src/util/currency/currency";

// The currency of the rate findPayDate shows — the same pick (today's entry, otherwise the latest one
// before today). Kept separate so findPayDate's "12.50/h" text, which callers parse, stays as it is.
// `fallback` is the tenant's default currency (useDefaultCurrency) for entries saved without one.
export function findPayCurrency(dates, fallback = DEFAULT_CURRENCY){
    if(!Array.isArray(dates)) return fallback;
    const today = dayjs();
    const entry = dates.find((date)=> dayjs(date?.effectivedate).isSame(today, 'day'))
        || [...dates].sort((a,b) => dayjs(b?.effectivedate) - dayjs(a?.effectivedate)).find((date)=> dayjs(date?.effectivedate).isBefore(today, 'day'));
    return entry?.currency || fallback;
}

// findPayDate's "12.50/h" with its currency symbol in front ("€12.50/h") — for display only.
export function formatPayRate(dates, fallback = DEFAULT_CURRENCY){
    const rate = findPayDate(dates);
    return rate ? `${currencySymbol(findPayCurrency(dates, fallback))}${rate}` : rate;
}

function rateSuffix(entry){
    if(entry?.frequency=="yearly") return "/y";
    if(entry?.frequency=="monthly") return "/m";
    return "/h";
}

export function findPayDate(dates) {
    let sameDate;
    if(Object.isFrozen(dates)){
        sameDate = Array.isArray(dates)? [...dates]?.find((date)=> dayjs(date?.effectivedate).isSame(dayjs(), 'day')) : {};

    }else{
        sameDate = Array.isArray(dates)? dates?.find((date)=> dayjs(date?.effectivedate).isSame(dayjs(), 'day')) : {};
    }
    
    if(sameDate && Object.keys(sameDate)?.length>0){
        if(sameDate?.rate){
            return sameDate?.rate+rateSuffix(sameDate);
        }else {
            return 0;
        }

    }else{

        let isBeforeDate;
        if(Object.isFrozen(dates) && Array.isArray(dates)){
            isBeforeDate = [...dates]?.sort((a,b) => dayjs(b?.effectivedate) - dayjs(a?.effectivedate))?.find((date)=> dayjs(date?.effectivedate).isBefore(dayjs(), 'day') );
        
        }else{
            isBeforeDate = dates?.sort((a,b) => dayjs(b?.effectivedate) - dayjs(a?.effectivedate))?.find((date)=> dayjs(date?.effectivedate).isBefore(dayjs(), 'day') );

        }

        if(isBeforeDate && isBeforeDate?.rate){
            return isBeforeDate?.rate+rateSuffix(isBeforeDate);
        }else{
            return 0;
        }

    }
   
}